import { ThemeEnum } from '@/shared/types/common.types';
import type { TModernShadow } from '@modern/theme/modern-theme.types';
import type { TModernThemeMode } from '@modern/theme/theme-mode/theme-mode.types';

export const MODERN_SHADOWS: Readonly<Record<TModernThemeMode, TModernShadow>> =
  {
    [ThemeEnum.DARK]: {
      dialog: '0 1.875rem 5.625rem rgba(0, 0, 0, 0.6)',
      menu: '0 0.875rem 2.5rem rgba(0, 0, 0, 0.55)',
      toast: '0 0.75rem 2.125rem rgba(0, 0, 0, 0.5)',
      tooltip: '0 0.75rem 2rem rgba(0, 0, 0, 0.6)',
    },
    [ThemeEnum.LIGHT]: {
      dialog: '0 1.875rem 5.625rem rgba(16, 24, 40, 0.2)',
      menu: '0 0.875rem 2.5rem rgba(16, 24, 40, 0.16)',
      toast: '0 0.75rem 2.125rem rgba(16, 24, 40, 0.16)',
      tooltip: '0 0.75rem 2rem rgba(16, 24, 40, 0.18)',
    },
  };
